function AboutThree({ item }) {
    return (
        <div className='px-4 flex flex-col gap-1 relative'>
            <img className='w-full h-auto' src={item.item.imageLink} alt={item.item.altText} />

            <div className="w-full flex flex-col gap-1 font-medium absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 px-6">
                <h1 className='text-[20px] leading-7 text-[#FFFFFF]'>{item.item.Heading}</h1>

                <p className='text-[14px] leading-[26px] text-[#B0B0B0]'>{item.item.Description}</p>
            </div>
        </div>
    );
}

export default AboutThree;
